import { Badge } from "@/components/ui";
import { cn } from "@/lib/utils";
import { STATUS_PUBLISHED } from "./consts";
import { StatusBadgeProps } from "./types";

export const StatusBadge = ({ status }: StatusBadgeProps) => (
  <Badge variant="outline" className={cn("rounded-full px-3",
    status === STATUS_PUBLISHED ? "border-green-600 bg-green-100 text-green-700" : "border-blue-500 bg-blue-50 text-blue-700")}>
    {status === STATUS_PUBLISHED ? "Published" : "Draft"}
  </Badge>
);
